import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
// Card components (to be created)
import ProfileCard from "../../components/employeeProfileCards/profileCard";
import CheckInOutCard from "../../components/employeeProfileCards/checkInOutCard";
import TaskCompletionCard from "../../components/employeeProfileCards/taskCompletionCard";
import BreakSummaryCard from "../../components/employeeProfileCards/summaryBreakCard";
import AttendanceHistoryCard from "../../components/employeeProfileCards/attendanceHistoryCard";
import CalendarCard from "../../components/employeeProfileCards/calenderCard";
import AttendanceCard from "../../components/card/attendanceCard";
import { useLocation } from "react-router-dom";
import { getWorkerDetails } from "../../services/Workers";
import AppLoader from "../../components/appLoader";
const EmployeeProfile = () => {
  const location = useLocation();
  const employeeId = location.state?.employeeId;
  const [isLoading, setIsLoading] = useState(false);
  const [workerData, setWorkerData] = useState(null);
  const [attendanceData, setAttendanceData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
 
  const employee = workerData
    ? {
        name: `${workerData.firstName} ${workerData.lastName}`,
        designation: workerData.designation || "Employee",
        id: workerData.employeeId || workerData._id,
        phone: workerData.contact || workerData.phone || "-",
        email: workerData.email || "-",
        photo:
          workerData.profileImage ||
          "https://randomuser.me/api/portraits/men/32.jpg",
        checkIn: attendanceData?.checkIn?.time || "-",
        checkOut: attendanceData?.checkOut?.time || "-",
      }
    : {
        name: "Loading...",
        designation: "Loading...",
        id: "Loading...",
        phone: "Loading...",
        email: "Loading...",
        photo: "https://randomuser.me/api/portraits/men/32.jpg",
        checkIn: "-",
        checkOut: "-",
      };

  const fetchWorkerDetails = async (date = selectedDate) => {
    if (!employeeId) return;

    setIsLoading(true);
    try {
      const response = await getWorkerDetails(employeeId, date);

      if (response?.data?.data) {
        const { worker, attendance } = response.data.data;
        setWorkerData(worker);
        setAttendanceData(attendance);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateChange = (newDate) => {
    // Get local date without timezone conversion
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const day = String(newDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    
    setSelectedDate(formattedDate);
    fetchWorkerDetails(formattedDate);
  };

  React.useEffect(() => {
    fetchWorkerDetails();
  }, [employeeId]);

  return (
    <Box
      bgcolor="primary.bgLight"
      padding={"20px"}
      borderRadius={"22px"}
      mt={0}
    >
      <AppLoader isVisible={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <ProfileCard employee={employee} />
          {/* <Box display="flex" gap={2} mt={2}>
            <CheckInOutCard label="Check - In Time" value={employee.checkIn} />
            <CheckInOutCard
              label="Check - Out Time"
              value={employee.checkOut}
              red
            />
          </Box> */}
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} md={6}>
                            <TaskCompletionCard data={taskCompletion} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <AttendanceHistoryCard data={attendanceHistory} />
                        </Grid> */}
            {/* <Grid item xs={12} md={6}>
                            <BreakSummaryCard data={breakSummary} />
                        </Grid> */}

            <Grid item xs={12} md={6}>
              <AttendanceCard
                checkIn={attendanceData?.checkIn?.time}
                checkOut={attendanceData?.checkOut?.time}
                breakIn={attendanceData?.breakIn?.time}
                breakOut={attendanceData?.breakOut?.time}
                status={attendanceData?.status}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  border: "2px solid #2E7D32",
                  borderRadius: "18px",
                  bgcolor: "#fff",
                }}
              >
                <CalendarCard onDateChange={handleDateChange} selectedDate={selectedDate} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmployeeProfile;
